export class CfetNavLablesConstant {
    public static CFETNAVLABLES = {
        header_links: {
            header_about: 'About',
            header_devices: 'Devices',
            header_plans: 'Plans',
            header_offers: 'Offers',
            header_agency_signup: 'Agency Signup',
            header_questions: 'Have questions?',
            header_check_eligibility: 'Check eligibility'
        },
        footer_menu: {
            firstnet_central: 'FirstNet Central',
            about_firstnet: 'About FirstNet',
            devices_service: 'Devices & service',
            firstnet_site_map: 'FirstNet Site map',
            privacy_policy: 'Privacy notice',
            terms_of_use: 'Terms of use',
            contact_us: 'Contact us',
            personal_information: 'Your Privacy Choices',
            health_notice: 'Health Privacy Notice',
            intellectual_property: '© {1} AT&T intellectual property.',
            rights: `All rights reserved. FirstNet, First Responder Network Authority, and FirstNet logo are registered trademarks
            and service marks of FirstNet, an independent authority within the U.S. Department of Commerce. All other marks are the
            property of their respective owners.`,
            website_maintain_info: 'This Website is maintained by AT&T.'
        }
    };
}
